var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("admin-preloader", { attrs: { show: _vm.loading } }),
      _vm._v(" "),
      _c("admin-breadcrumb", {
        attrs: {
          items: [{ text: "Taxonomies", path: { name: "admin-taxonomies" } }],
          name: "Subcategories",
          "no-title": "",
        },
      }),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "admin-panel",
                {
                  attrs: { title: "Subcategories" },
                  scopedSlots: _vm._u([
                    {
                      key: "header-right",
                      fn: function () {
                        return [
                          _c("b-form-select", {
                            staticClass: "w-auto mr-2",
                            attrs: { options: _vm.categoryTypeOptions },
                            model: {
                              value: _vm.filters.category_type,
                              callback: function ($$v) {
                                _vm.$set(_vm.filters, "category_type", $$v)
                              },
                              expression: "filters.category_type",
                            },
                          }),
                          _vm._v(" "),
                          _c("b-form-select", {
                            staticClass: "w-auto mr-2",
                            attrs: { options: _vm.categoryOptions },
                            model: {
                              value: _vm.filters.category,
                              callback: function ($$v) {
                                _vm.$set(_vm.filters, "category", $$v)
                              },
                              expression: "filters.category",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "no-permission-wrapper",
                            { attrs: { show: !_vm.canCreateTaxonomies } },
                            [
                              _c(
                                "b-btn",
                                {
                                  attrs: {
                                    variant: "success",
                                    disabled: !_vm.canCreateTaxonomies,
                                  },
                                  on: { click: _vm.openNewModal },
                                },
                                [_vm._v("Add new Subcategory")]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _vm._v(" "),
                  _c("b-table", {
                    attrs: {
                      fields: _vm.table_fields,
                      items: _vm.subcategories,
                      "table-class": "text-nowrap",
                      responsive: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "cell(name)",
                        fn: function (data) {
                          return [
                            _c("h4", { staticClass: "mb-0" }, [
                              _vm._v(_vm._s(data.item.name)),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "cell(category_types)",
                        fn: function (data) {
                          return _vm._l(
                            data.item.category_types,
                            function (ct, key) {
                              return _c("div", { key: key }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(ct.name) +
                                    "\n            "
                                ),
                              ])
                            }
                          )
                        },
                      },
                      {
                        key: "cell(categories)",
                        fn: function (data) {
                          return _vm._l(
                            data.item.categories,
                            function (c, key) {
                              return _c("div", { key: key }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(c.name) +
                                    "\n            "
                                ),
                              ])
                            }
                          )
                        },
                      },
                      {
                        key: "cell(actions)",
                        fn: function (data) {
                          return [
                            _c(
                              "no-permission-wrapper",
                              { attrs: { show: !_vm.canUpdateTaxonomies } },
                              [
                                _c(
                                  "b-btn",
                                  {
                                    attrs: {
                                      variant: "primary",
                                      disabled: !_vm.canUpdateTaxonomies,
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.openEditModal(data.item)
                                      },
                                    },
                                  },
                                  [_vm._v("Edit")]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "no-permission-wrapper",
                              { attrs: { show: !_vm.canDeleteTaxonomies } },
                              [
                                _c(
                                  "b-btn",
                                  {
                                    attrs: {
                                      variant: "danger",
                                      disabled: !_vm.canDeleteTaxonomies,
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.confirmDelete(data.item)
                                      },
                                    },
                                  },
                                  [_vm._v("Delete")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.edit_subcategory
        ? _c("admin-subcategory-edit-modal", {
            attrs: { subcategory: _vm.edit_subcategory, visible: "" },
            on: {
              cancel: function ($event) {
                _vm.edit_subcategory = null
              },
              success: _vm.onSubcategoryEdited,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("admin-subcategory-add-modal", {
        ref: "newModal",
        on: { success: _vm.onSubcategoryAdded },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }